import { FormLayoutBuilder, getFormData } from '@pihealth/common-ui-library';
import Loader from 'src/components/common/Loader';
import AppModal from 'src/components/modal';
import forms from '../../../../../resources/forms.json';
import { useRef, useEffect, useState } from 'react';
import { Checkbox, FormControlLabel, Grid, Typography } from '@mui/material';
import { useClenderEvents } from '../useClenderEvents';
import { useAppSelector } from 'src/store/hooks';
import { useAppDispatch } from 'src/store';
import { useUser } from 'src/components/hooks/useUser';
import { setMessage } from 'src/store/Message';
import { useUtil } from 'src/components/hooks/useUtil';
import { hideLoader, showLoader } from 'src/store/Loader';
import { convertToMinutes } from 'src/util/util';
import moment from 'moment';
import { usePreferedDateFormat } from 'src/util/DateFormatter';

const UnscheduleVisitDialog: React.FunctionComponent<any> = props => {
  const {
    openUnschedulePopup,
    setOpenUnschedulePopup,
    durationList,
    subjectsList,
    visitCrfs,
    setVisitCrfs,
    onSuccess,
    tempSubjectVisitsEvents
  } = props;
  const formGroup = forms.UnscheduledVisit;
  const { formFields, defaultValues = {}, rules } = getFormData(formGroup.groups);
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const [updateKey, setUpdateKey] = useState<number>(1);
  const { userPreferedDateFormat } = usePreferedDateFormat();
  const {
    createUnscheduledVisit,
    createUnscheduledVisitData,
    createUnscheduledVisitIsLoading,
    createUnscheduledVisitIsError,
    createUnscheduledVisitError,
    createUnscheduledVisitIsSuccess
  } = useClenderEvents();
  const { user } = useUser();
  const { handleError } = useUtil();
  const formRef: any = useRef(null);
  const { groups } = formFields;
  const dispatch = useAppDispatch();
  const [initialValues, setInitialvalues] = useState(defaultValues);
  const handleCloseUnschedulePopup = () => {
    setOpenUnschedulePopup(false);
    setInitialvalues({});
    setVisitCrfs(
      visitCrfs.map((ele: any) => {
        return {
          ...ele,
          checked: false
        };
      })
    );
  };
  const handleCbxChange = (crfId: any) => (event: any) => {
    const selectedCrfs: any = visitCrfs.map((item: any) =>
      item?.id === crfId ? { ...item, checked: event.target.checked } : item
    );
    setVisitCrfs(selectedCrfs);
  };
  const handleChangeForm = (key: any, value: any) => {
    initialValues[key] = value;
    if (key === 'subject_id') {
      const find = tempSubjectVisitsEvents?.find((ele: any) => ele.subject_id === value);
      if (!find?.crf_activated) {
        dispatch(
          setMessage({
            msgDetails: `Activate CRF step must be completed for a subject to create unscheduled visit`,
            severity: 'error'
          })
        );
        initialValues[key] = null;
      }
      setUpdateKey(prev => prev + 1);
    }
    setInitialvalues(initialValues);
  };

  const handleSave = () => {
    formRef.current.submit(onFormSubmit);
  };
  const onFormSubmit = (data: any) => {
    if (data.errors) {
      return;
    }
    if (data.success) {
      if (visitCrfs?.find((ele: any) => ele.checked)) {
        const selectedCrfIds: any = visitCrfs?.filter((ele: any) => ele.checked)?.map((el: any) => el.id);
        const durationInMinutes = convertToMinutes(data?.records?.duration?.trim());
        createUnscheduledVisit({
          data: {
            ...data.records,
            crf_form_ids: selectedCrfIds,
            created_by: user,
            duration: durationInMinutes,
            start_on: moment(data?.records?.start_on, 'MM/DD/YYYY hh:mm A').format('YYYY-MM-DD HH:mm:ss')
          },
          study_id: studyId,
          country: selectedCountry,
          site_id: selectedSite,
          application: process.env.REACT_APP_NAME_TEMP
        });
      } else {
        dispatch(
          setMessage({ msgDetails: `Minimum one CRF must be selected for unscheduled visit`, severity: 'error' })
        );
      }
    }
  };
  useEffect(() => {
    if (createUnscheduledVisitIsError) {
      handleError(createUnscheduledVisitError);
    }
    createUnscheduledVisitIsLoading ? dispatch(showLoader()) : dispatch(hideLoader());
  }, [createUnscheduledVisitIsError, createUnscheduledVisitIsLoading]);

  useEffect(() => {
    if (createUnscheduledVisitData && createUnscheduledVisitIsSuccess) {
      dispatch(setMessage({ msgDetails: `Unscheduled visit is created successfully`, severity: 'success' }));
      setInitialvalues({});
      setVisitCrfs(
        visitCrfs.map((ele: any) => {
          return {
            ...ele,
            checked: false
          };
        })
      );
      onSuccess();
      setOpenUnschedulePopup(false);
    }
  }, [createUnscheduledVisitData, createUnscheduledVisitIsSuccess]);

  useEffect(() => {
    if (openUnschedulePopup) {
      groups?.map((obj: any) => {
        obj?.fields.map((field: any) => {
          if (field.name === 'duration') {
            field.values = durationList?.map((list: any) => list.code_list_value);
          }
          if (field.name === 'subject_id') {
            field.values = subjectsList;
          }
        });
      });
    }
  }, [openUnschedulePopup]);
  return (
    <>
      <AppModal
        open={openUnschedulePopup}
        title={formGroup.header}
        saveButton={'Save'}
        closeButton={'Close'}
        handleSubmit={handleSave}
        handleClose={handleCloseUnschedulePopup}
        maxWidth="600px"
        outSideClickClose
        className="modalWithBlurFix"
      >
        <Loader />
        <FormLayoutBuilder
          key={updateKey}
          initialValues={initialValues}
          rules={rules}
          ref={formRef}
          groups={groups}
          columnSpacing={2}
          onChange={handleChangeForm}
          dateFormat={userPreferedDateFormat}
        />
        <Typography variant="h5" mt="8px" sx={{ fontSize: 'clamp(13px, 14px, 16px)', fontWeight: 500 }}>
          <strong>Choose assessment(s) for this unscheduled appointment:</strong>
        </Typography>

        {visitCrfs?.length > 0 ? (
          <Grid
            container
            spacing={2}
            mt={1}
            sx={{
              '& .MuiFormGroup-root .MuiFormControlLabel-root': { marginBottom: '8px' },
              wordBreak: 'break-word',
              height: '25vh',
              overflow: 'auto',
            }}
          >
            {visitCrfs?.map((crfData: any) => {
              return (
                <>
                  <Grid key={crfData.id} item md={4}>
                    <div>
                      <FormControlLabel
                        control={
                          <Checkbox checked={crfData?.checked || false} onChange={handleCbxChange(crfData.id)} />
                        }
                        label={crfData.custom_name ? crfData.custom_name : crfData.OID}
                      />
                    </div>
                  </Grid>
                </>
              );
            })}
          </Grid>
        ) : (
          <p className="alert alert-warning" style={{ marginBottom: "32px"}}>
            No CRF configured for the unscheduled visit in study calendar. Please contact system administrator
          </p>
        )}
      </AppModal>
    </>
  );
};

export default UnscheduleVisitDialog;
